var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.5@core-js/library/modules/_an-object.js
// module id = 152
// module chunks = 16